
import { TFunction } from 'i18next';
import { ReactComponent as ShareIcon } from '../icons/share.svg';
import { ReactComponent as AircraftIcon } from '../icons/aircraft.svg';
import { ReactComponent as CodeIcon } from '../icons/code.svg';
import { ReactComponent as DeviceTvIcon } from '../icons/device-tv.svg';
import { ReactComponent as DelayCommIcon } from '../icons/mail.svg';
import { ReactComponent as UserFeedbackIcon } from '../icons/light-bulb.svg';
// import { ReactComponent as LoudspeakerIcon } from '../icons/loudspeaker.svg';
import { ADMIN, AIRCRAFTS, AIRPORTS, AUDITLOG, DASHBOARD, DELAYCOMM, FLIGHTLIST, PREMMEALLIST, USERFEEDBACK } from '../common/paths';

export interface INavigationItem {
    id: string,
    icon?: React.ElementType,
    label: string,
    children?: INavigationItem[],
    path: string,
    rootPath: string,
}

export interface INavigationGroup {
    id: string,
    label: string,
    children: INavigationItem[],
}

export function getNavigationItemGroups(t: TFunction, rootPath: string): INavigationGroup[] {
    return [
        {
            id: 'general',
            label: t('General'),
            children: [
                {
                    id: 'dashboard',
                    label: t('Dashboard'),
                    icon: DeviceTvIcon,
                    path: DASHBOARD,
                    rootPath,
                },
                {
                    id: 'home',
                    label: t('Home'),
                    icon: ShareIcon,
                    path: '',
                    rootPath,
                },
                {
                    id: 'flight-list',
                    label: t('Flights'),
                    icon: AircraftIcon,
                    path: FLIGHTLIST,
                    rootPath,
                },
                {
                    id: 'delaycomm',
                    label: t('Delay Comm'),
                    icon: DelayCommIcon,
                    path: DELAYCOMM,
                    rootPath,
                },
                {
                    id: 'premmeal',
                    label: t('Prem Meal'),
                    icon: DelayCommIcon,
                    path: PREMMEALLIST,
                    rootPath,
                },
                {
                    id: 'userfeedback',
                    label: t('User Feedback'),
                    icon: UserFeedbackIcon,
                    path: USERFEEDBACK,
                    rootPath,
                },
                // {
                //     id: 'cabincast',
                //     label: t('Cabin Cast'),
                //     icon: LoudspeakerIcon,
                //     path: CABINCAST,
                //     rootPath,
                //     children: [
                //         {
                //             id: 'audiofiles',
                //             label: t('Audio Files'),
                //             path: CABINCAST_AUDIOFILES,
                //             rootPath,
                //         }
                //     ],
                // },
            ],
        },
        {
            id: 'administration',
            label: t('Administration'),
            children: [
                {
                    id: 'airports',
                    label: t('Airline Data'),
                    icon: ShareIcon,
                    path: ADMIN,
                    rootPath,
                    children: [
                        {
                            id: 'airports',
                            label: t('Airports'),
                            icon: ShareIcon,
                            path: AIRPORTS,
                            rootPath,
                        },
                        {
                            id: 'aircrafts',
                            label: t('Aircrafts'),
                            icon: AircraftIcon,
                            path: AIRCRAFTS,
                            rootPath,
                        }
                    ],
                    
                },
                {
                    id: 'audit',
                    label: t('Audit Log'),
                    icon: CodeIcon,
                    path: AUDITLOG,
                    rootPath,
                }
                
            ],
        },
    ]
}